import { render, staticRenderFns } from "./Quran.vue?vue&type=template&id=b250f46c&"
import script from "./Quran.vue?vue&type=script&lang=js&"
export * from "./Quran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports